export const InstructionsGraphics = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="210"
      height="160"
      fill="none"
    >
      <path
        stroke="#E1E1E1"
        strokeWidth="2"
        d="M67 86.5c16.5 0 3.5-14.5 17.5-14.5M144 96.5c-16.5 0-1-24.5-19-24.5"
      ></path>
      <rect
        width="46"
        height="10"
        x="22"
        y="31"
        fill="#F8F8F8"
        stroke="#E1E1E1"
        strokeWidth="2"
        rx="1"
      ></rect>
      <rect
        width="46"
        height="19"
        x="22"
        y="49"
        fill="#F8F8F8"
        stroke="#E1E1E1"
        strokeWidth="2"
        rx="1"
      ></rect>
      <rect
        width="46"
        height="19"
        x="22"
        y="103"
        fill="#F8F8F8"
        stroke="#E1E1E1"
        strokeWidth="2"
        rx="1"
      ></rect>
      <rect
        width="46"
        height="18"
        x="82"
        y="31"
        fill="#F8F8F8"
        stroke="#E1E1E1"
        strokeWidth="2"
        rx="1"
      ></rect>
      <rect
        width="46"
        height="33"
        x="82"
        y="55"
        fill="#EAF6F4"
        stroke="#125970"
        strokeWidth="2"
        rx="1"
      ></rect>
      <path
        fill="#7DA9B3"
        fillRule="evenodd"
        d="M123 78.946H87V77h36v1.946zm0 4H87V81h36v1.946z"
        clipRule="evenodd"
        opacity="0.5"
      ></path>
      <rect width="11" height="11" x="87" y="60" fill="#7DA9B3" rx="2"></rect>
      <rect
        width="46"
        height="18"
        x="82"
        y="94"
        fill="#F8F8F8"
        stroke="#E1E1E1"
        strokeWidth="2"
        rx="1"
      ></rect>
      <rect
        width="46"
        height="18"
        x="82"
        y="118"
        fill="#F8F8F8"
        stroke="#E1E1E1"
        strokeWidth="2"
        rx="1"
      ></rect>
      <rect
        width="46"
        height="18"
        x="142"
        y="31"
        fill="#F8F8F8"
        stroke="#E1E1E1"
        strokeWidth="2"
        rx="1"
      ></rect>
      <rect
        width="46"
        height="18"
        x="142"
        y="55"
        fill="#F8F8F8"
        stroke="#E1E1E1"
        strokeWidth="2"
        rx="1"
      ></rect>
      <rect
        width="46"
        height="33"
        x="142"
        y="79"
        fill="#EAF6F4"
        stroke="#125970"
        strokeWidth="2"
        rx="1"
      ></rect>
      <path
        fill="#7DA9B3"
        fillRule="evenodd"
        d="M183 102.946h-36V101h36v1.946zm0 4h-36V105h36v1.946z"
        clipRule="evenodd"
        opacity="0.5"
      ></path>
      <rect width="11" height="11" x="147" y="84" fill="#7DA9B3" rx="2"></rect>
      <rect
        width="46"
        height="18"
        x="142"
        y="118"
        fill="#F8F8F8"
        stroke="#E1E1E1"
        strokeWidth="2"
        rx="1"
      ></rect>
      <rect
        width="46"
        height="23"
        x="22"
        y="74"
        fill="#EAF6F4"
        stroke="#125970"
        strokeWidth="2"
        rx="1"
      ></rect>
      <rect
        width="11"
        height="11"
        x="26.333"
        y="78"
        fill="#7DA9B3"
        rx="2"
      ></rect>
      <circle cx="58.5" cy="86.5" r="5.5" fill="#125970"></circle>
      <mask
        id="a"
        width="20"
        height="27"
        x="112"
        y="78"
        fill="#000"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#fff" d="M112 78h20v27h-20z"></path>
        <path
          fillRule="evenodd"
          d="M115 83l2.759 16.097 4.261-2.778 3.073 5.313 2.988-2.146-3.652-4.739 3.908-2.549L115 83z"
          clipRule="evenodd"
        ></path>
      </mask>
      <path
        fill="#000"
        fillRule="evenodd"
        d="M115 83l2.759 16.097 4.261-2.778 3.073 5.313 2.988-2.146-3.652-4.739 3.908-2.549L115 83z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#fff"
        d="M117.759 99.097l-1.971.338.515 3 2.549-1.663-1.093-1.675zM115 83l1.135-1.646-3.909-2.696.803 4.68L115 83zm7.02 13.319l1.731-1.002-1.056-1.826-1.768 1.152 1.093 1.676zm3.073 5.313l-1.732 1.002 1.105 1.91 1.793-1.287-1.166-1.625zm2.988-2.146l1.167 1.625 1.681-1.207-1.263-1.638-1.585 1.22zm-3.652-4.739l-1.093-1.675-1.813 1.182 1.322 1.714 1.584-1.22zm3.908-2.549l1.093 1.676 2.498-1.63-2.455-1.692-1.136 1.646zm-8.606 6.561l-2.76-16.097-3.942.676 2.759 16.097 3.943-.676zm1.196-4.116l-4.26 2.779 2.185 3.35 4.26-2.778-2.185-3.35zm5.897 5.988l-3.073-5.314-3.463 2.003 3.073 5.314 3.463-2.003zm.091-2.77l-2.989 2.147 2.333 3.249 2.989-2.146-2.333-3.25zm-4.07-1.893l3.652 4.739 3.169-2.441-3.653-4.74-3.168 2.442zm4.4-5.445l-3.909 2.55 2.185 3.35 3.909-2.55-2.185-3.35zm-13.38-5.877l13.337 9.199 2.271-3.293-13.338-9.198-2.27 3.292z"
        mask="url(#a)"
      ></path>
    </svg>
  );
};
